import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit {
  isloaderShow: boolean = true;
  closeForLoader() {
    this.isloaderShow = false;
  }
  constructor() {}
  ngOnInit(): void {}
}
